import React, { Component } from "react";
import { authService } from "../../../auth";
import axios from "axios";
import { Link } from "react-router-dom";
class ProjectHashTagsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            hashTagsList: []
        }
    }

    getProjectHashtags = () => {
        let postData = {
            projectId: this.props.entityId
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/projecthastags`,
            data: postData,
            withCredentials: true
        }).then((response) => {
            if(response?.data?.status === 200) {
                this.setState({
                    hashTagsList: response?.data?.data
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    componentDidMount() {
        this.getProjectHashtags();
    }

    render() {
        const { hashTagsList } = this.state;
        return (
            <>
                {hashTagsList && hashTagsList.length > 0 && 
                    <div className={hashTagsList && hashTagsList.length === 1 ? "prjHmCommonSec prjHmHasTagsSec justify-content-start p-0" : "prjHmCommonSec prjHmHasTagsSec"}>
                        {hashTagsList && hashTagsList.map((tag) => {
                            return (
                                <Link className="hashLinkPost" to={`/explore-hashtag/${tag}`}>{tag}</Link>
                            )
                        })}
                    </div>
                }
            </>
        )
    }
}

export default ProjectHashTagsSection;